<template>
<div class="oudonate-other-amount" :class="form.currency">
  <div class="amount_other__wrapper" style="max-width: 200px">
      <input id="amount_other" type="number" min="1" name="amount_other" v-model="customAmount" placeholder="0"/>
  </div>
</div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

const paymentForm = usePaymentForm()

if (!paymentForm) {
  throw new Error('PaymentForm context not available')
}

const { setValue, form, settings } = paymentForm

const selectedAmount = ref()
const customAmount = ref(form.value.amount)

watch(selectedAmount, (selectedAmount) => {
  if (selectedAmount) {
    customAmount.value = null

    setValue('amount', '' + selectedAmount)
  }
})

watch(customAmount, (customAmount) => {
  if (customAmount) selectedAmount.value = null

  if (!selectedAmount.value) setValue('amount', customAmount || null)
})

const amounts = computed(() => {
  const amounts = settings!.amounts!

  if (Array.isArray(amounts)) {
    return amounts
  }

  return amounts[form.value.currency || 'USD']
})
</script>
<style scoped lang="scss">
.oudonate-other-amount {
  .amount_other__wrapper{
    position: relative;
    margin-right: 0;
    min-width: 16.6%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    flex: 1;
    padding-left: 5px;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
    }
    &:before {
      content: '$';
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f9fb;
      top: 0px;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;      
    }

    input[type='number'] {
      border: none;
      margin-left: 20px;
      padding-left: 20px;
      box-shadow: none;
    }
    &:after {
      display: none !important;
    }    
  }
    &.USD .amount_other__wrapper:before {content: '$'}
    &.CAD .amount_other__wrapper:before {content: 'C$'; padding: 15px 4px 15px 8px;}
    &.ILS .amount_other__wrapper:before {content: '₪'}  
}

.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type='number'] {
      background: #fff;
      margin-top: -15px;
    }
  }
}  
</style>